import React, { Component } from 'react';
import track from 'react-tracking';
import numeral from 'numeral';
import { connect } from 'react-redux';
import {
  ButtonList, AdvisorPicker, WeekDayPicker, TimePicker, ChatInput,
} from 'components';
import { LayoutChat } from 'layouts';
import {
  COMPONENT_TYPE, delayTime, PATH, TRACKING_VALUE,
} from 'shared/constants';
import { getRTL, getSimulationData } from 'shared/redux/selectors';
import {
  submitReply, updateSummary, updateStep, clearConversationHistory,
} from 'shared/redux/actions';
import trackEvent from 'components/TrackEvent';
import { eventGetInTouchEmail, eventGetInTouchMeetAdvisor, eventGetInTouchOpenAccount } from 'components/TrackEvent/constEvent';
import iconClose from 'assets/icons/iconTopbarClose.png';
import iconAdvisor from 'assets/icons/icon-advisor.svg';
import iconEmail from 'assets/icons/icon-email.svg';
import iconOpenAccount from 'assets/icons/icon-open-account.svg';
import baseUrl from 'shared/util/baseUrl';
import { injectIntl } from 'react-intl';
import { submitAppointment, sendEmail, generatePDf } from 'shared/redux/actions/cta';
import moment from 'moment';
import _ from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRedo } from '@fortawesome/free-solid-svg-icons';
import { isIOS, isMobileSafari } from 'react-device-detect';
import ultilitiesService from 'shared/util/ultilitiesService';
import {
  trackCTA,
  trackAvisorAppointment,
  trackInput,
  trackCompleteProspect,
} from './CallToAction.tracking';

class CallToAction extends Component {
  state = {
    appointmentSummary: {},
  };

  // componentDidMount() {
  //   /** Invoke generate PDF to get Asset Allocation Ref Code (to be used in Asset Allocation) */
  //   this.props.onGeneratePDf();
  // }

  componentDidUpdate(prevProps) {
    const { submitAppointmentSuccess } = this.props;

    if (!_.isEqual(prevProps.submitAppointmentSuccess, submitAppointmentSuccess) && submitAppointmentSuccess === true) {
      this.props.history.push(PATH.THANK_YOU);
    }
  }

  handleRestart = () => {
    const { onClearConversationHistory, onReplySubmit } = this.props;
    onClearConversationHistory().then(() => onReplySubmit('restart'));
  };

  processButtonIconList = (inputOptions) => {
    const { summary } = this.props;
    const initialInvestment = numeral(summary['summary.initialInvestment']).value();
    const returnIcon = (payload) => {
      switch (payload) {
        case 'meet_advisor':
          return iconAdvisor;
        case 'open_account':
          return iconEmail;
        case 'email_product':
          return iconOpenAccount;
        default:
          return null;
      }
    };

    /** remove meet advisor option if initial capital is below 100k */
    const filterOptions = initialInvestment <= 99999 ? inputOptions.filter(item => item.payload !== 'meet_advisor') : inputOptions;

    return filterOptions.map(item => ({
      text: item.text,
      icon: returnIcon(item.payload),
      iconActive: returnIcon(item.payload),
      payload: item.payload,
    }));
  };

  processApplicationIconList = (inputOptions) => {
    const returnIcon = (payload) => {
      switch (payload) {
        case 'email_forms':
          return iconEmail;
        case 'go_to_cob':
          return iconOpenAccount;
        default:
          return null;
      }
    };
    return inputOptions.map(item => ({
      text: item.text,
      icon: returnIcon(item.payload),
      iconActive: returnIcon(item.payload),
      payload: item.payload,
    }));
  };

  processAdvisor = (inputOptions) => {
    // const sortByTitle = (a, b) => {
    //   if (a.title < b.title) return -1;
    //   if (a.title > b.title) return 1;
    //   return 0;
    // };
    const { intl } = this.props;

    // const orderKeys = [2, 0, 1, 3];
    const orderKeys = [2, 0, 3, 4, 1];
    const advisors = orderKeys.map(key => inputOptions[key]);

    return [...advisors.map(item => ({
      id: item.id,
      icon: `${baseUrl}/images${item.avatar}`,
      title: item.payload,
      desc: item.desc,
    })),
    {
      title: intl.formatMessage({ id: 'cta.anyOfThem' }),
      id: 'anyOfThem',
    }];
  };

  handleFinish = () => {
    const {
      onSubmitAppointment, summary, simulationData, onSendEmail, tracking, intl,
    } = this.props;

    if (
      summary['summary.proceedOption'] === 'email_product'
      || summary['summary.proceedOption'] === 'meet_advisor'
      // || (summary['summary.proceedOption'] === 'open_account' && summary['summary.email'] !== intl.formatMessage({ id: 'welcome.skip' }))
      || (summary.hasOwnProperty('summary.applicationVia') && summary['summary.applicationVia'] !== 'go_to_cob')
    ) {
      // console.log('use this data to submit to email api', simulationData);
      onSendEmail(simulationData).then((refCode) => {
        /**
         * Tracking advisor appointment
         */
        if (summary['summary.proceedOption'] === 'meet_advisor') {
          const { appointmentSummary } = this.state;
          const initialInvestment = numeral(summary['summary.initialInvestment']).value();
          const isRetail = initialInvestment >= 5000 && initialInvestment <= 99999;
          const isAffluent = initialInvestment >= 100000 && initialInvestment <= 250000;
          trackAvisorAppointment(tracking, {
            ...appointmentSummary,
            refCode,
            // fund: fundDetail.title || '',
            investableAsset: summary['summary.initialInvestment'] || '',
            name: summary['summary.name'] || '',
            age: summary['summary.age'].split(' Year')[0],
            assets: summary['summary.targetAmount'],
            goal: intl.formatMessage({ id: summary['summary.goal'] }),
            risk: intl.formatMessage({ id: summary['summary.risk'] }),
            // cma: intl.formatMessage({ id: summary['summary.regulatoryClassification'] }, { textQualified: 'no', textRetail: 'no' })
            //   .split(' ')[1]
            //   .split('Investor')[0],
            // eslint-disable-next-line no-nested-ternary
            clientSegment: isRetail ? 'retail' : isAffluent ? 'affluent' : 'private',
            dateTime: `${moment().locale('en').format('DD/MM/YY')}, ${moment().format('HH:mm')}`,
            cta: 'Appointment',
            rating: '0',
          });
        }

        // for prospect
        ultilitiesService.handleCompleteProspect(refCode, summary, intl, tracking, -1, trackCompleteProspect);
        /** */
      });
    }


    if (summary['summary.proceedOption'] !== 'meet_advisor') {
      this.props.history.push(PATH.THANK_YOU);
      return;
    }

    // let advisorId;
    // // random advisor if select any of them
    // if (summary['summary.managerID'] === 'anyOfThem') {
    //   advisorId = summary['summary.managerList'] && _.sample(summary['summary.managerList'].map(item => item.id));
    // } else {
    //   advisorId = summary['summary.managerID'];
    // }
    const data = {
      // address: summary['summary.preferredLocation'], // use this instead when location is needed
      address: 'Zoom meeting', // temporarily use this as address since this is a required field
      advisorId: summary['summary.managerID'] === 'anyOfThem' ? null : summary['summary.managerID'],
      appointmentDatetime: moment(`${summary['summary.preferredTime']} ${summary['summary.preferredDate']}`, 'hh:mm A dddd, D MMMM YYYY').locale('en').format('YYYY-MM-DD kk:mm:ss'),
      clientEmail: summary['summary.email'],
      // eslint-disable-next-line no-underscore-dangle
      clientId: 1,
      countryCode: 'KWT',
      notificationMethod: 'email',
    };
    onSubmitAppointment(data);
  };


  render() {
    const {
      conversations,
      inputComponent,
      inputOptions,
      onReplySubmit,
      messageOptions,
      onUpdateSummary,
      tracking,
      isRtl,
      intl,
      currentLocale,
      onGeneratePDf,
      summary,
      // referenceCode,
    } = this.props;

    const { appointmentSummary } = this.state;

    let input;

    switch (inputComponent) {
      case COMPONENT_TYPE.OPTION_WITH_ICON:
        input = (
          <ButtonList
            buttonWithIconList={this.processButtonIconList(inputOptions)}
            onButtonClick={(reply, option) => {
              setTimeout(() => {
                onReplySubmit(reply, option);
                onUpdateSummary({ 'summary.proceedOption': reply });
                /** track CTA */
                trackCTA(tracking, reply);
                // console.log(reply);
                switch (reply) {
                  case 'email_product':
                    trackEvent(eventGetInTouchEmail(currentLocale));
                    break;
                  case 'open_account':
                    trackEvent(eventGetInTouchOpenAccount(currentLocale));
                    break;
                  case 'meet_advisor':
                    trackEvent(eventGetInTouchMeetAdvisor(currentLocale));
                    break;
                  default:
                    break;
                }
                /** */
              }, delayTime);
            }}
            isButtonWithIcon
            rtl={isRtl}
          />
        );
        break;
      case COMPONENT_TYPE.APPLICATION_OPTIONS:
        input = (
          <ButtonList
            buttonWithIconList={this.processApplicationIconList(inputOptions)}
            onButtonClick={(reply, option) => {
              onReplySubmit(reply, option);
              onUpdateSummary({ 'summary.applicationVia': reply });
            }}
            isButtonWithIcon
            rtl={isRtl}
          />
        );
        break;
      case COMPONENT_TYPE.ADVISOR_PICKER:
        input = (
          <AdvisorPicker
            data={this.processAdvisor(inputOptions)}
            onSubmit={(reply, option) => {
              onUpdateSummary({ 'summary.managerList': inputOptions });
              setTimeout(() => onReplySubmit(reply, option), delayTime);
              /** track appointment relationship */
              let manager;
              if (option.managerID === 'anyOfThem') {
                // manager = _.sample(inputOptions.map(item => item.payload));
                manager = 'anyOfThem';
              } else {
                manager = reply;
              }
              appointmentSummary.manager = manager;
              this.setState({ appointmentSummary });

              onUpdateSummary({ 'summary.managerID': option.managerID ? option.managerID : manager });
              onUpdateSummary({ 'summary.advisorName': option.advisorName });
              onUpdateSummary({ 'summary.advisorTitle': option.advisorTitle });
              // trackRelationshipManager(tracking, manager);
              /** */
            }}
            rtl={isRtl}
          />
        );
        break;
      case COMPONENT_TYPE.DATE_PICKER:
        input = (
          <WeekDayPicker
            startOfWeek="saturday"
            onSubmit={(reply, option) => {
              onUpdateSummary({ 'summary.preferredDate': reply });
              setTimeout(() => onReplySubmit(reply, option), delayTime);
              /** track appointment date */
              trackInput(tracking, `${summary['summary.proceedOption']}_enter_week`, reply);

              appointmentSummary.date = option.pureDate.locale('en').format('DD/MM/YYYY');
              this.setState({ appointmentSummary });
              // trackDateAppoint(tracking, option.pureDate.format('DD/MM/YYYY'));
              /** */
            }}
            rtl={isRtl}
          />
        );
        break;
      case COMPONENT_TYPE.TIME_PICKER:
        input = (
          <TimePicker
            onSubmit={(reply, option) => {
              onUpdateSummary({ 'summary.preferredTime': reply });
              onReplySubmit(reply, option);
              /** track appointment time */
              trackInput(tracking, `${summary['summary.proceedOption']}_enter_time`, reply);
              appointmentSummary.preferredTime = reply;
              this.setState({ appointmentSummary });
              // trackTimeAppoint(tracking, reply);
              /** */
            }}
            rtl={isRtl}
          />
        );
        break;
      case COMPONENT_TYPE.PICK_LOCATION:
        input = (
          <ButtonList
            optionList={inputOptions}
            onOptionClick={(reply) => {
              onUpdateSummary({ 'summary.preferredLocation': reply });
              onReplySubmit(reply);
              /** track appointment location */
              if (reply === 'markaz_office') {
                // trackLocation(tracking, reply);
                appointmentSummary.location = TRACKING_VALUE.OFFICE_LOCATION;
                this.setState({ appointmentSummary });
              }
              /** */
            }}
            isOptionButton
            rtl={isRtl}
          />
        );
        break;
      case COMPONENT_TYPE.LOCATION_INPUT:
        input = (
          <ChatInput
            placeholder="input.enterYourLocation"
            onSubmit={(reply) => {
              onUpdateSummary({ 'summary.preferredLocation': reply });
              onReplySubmit(reply, { toTranslate: false });
              /** track appointment location */
              // trackLocation(tracking, reply);
              appointmentSummary.location = reply;
              this.setState({ appointmentSummary });
              /** */
            }}
            rtl={isRtl}
          />
        );
        break;
      case COMPONENT_TYPE.EMAIL:

        input = (
          <ChatInput
            isEmail
            placeholder="input.enterYourEmail"
            onSubmit={(reply) => {
              trackInput(tracking, `${summary['summary.proceedOption']}_enter_email`, reply);
              onUpdateSummary({ 'summary.email': reply });
              onReplySubmit(reply, { toTranslate: false });
              /** track user email */
              // trackUserEmail(tracking, reply);
              appointmentSummary.email = reply;
              this.setState({ appointmentSummary });
              /** */
            }}
            hookValue={messageOptions ? messageOptions.email : null}
            rtl={isRtl}
          />
        );
        break;
      case COMPONENT_TYPE.PHONE_NUMBER:
        input = (
          <ChatInput
            placeholder="input.enterYourPhone"
            onSubmit={(reply) => {
              onUpdateSummary({ 'summary.phone': reply });
              onReplySubmit(reply, { toTranslate: false });
              /** track user phone */
              // trackUserPhone(tracking, reply);
              trackInput(tracking, `${summary['summary.proceedOption']}_enter_phone`, reply);

              appointmentSummary.phone = reply !== intl.formatMessage({ id: 'welcome.skip' }) ? reply : '';
              this.setState({ appointmentSummary });
              /** */
            }}
            type="tel"
            skipable={messageOptions.skipOn === 'open_account' ? intl.formatMessage({ id: 'welcome.skip' }) : null}
            rtl={isRtl}
          />
        );
        break;
      case COMPONENT_TYPE.OPTIONAL_EMAIL:
        input = (
          <ChatInput
            placeholder="input.enterYourEmail"
            onSubmit={(reply) => {
              onUpdateSummary({ 'summary.email': reply });
              onReplySubmit(reply, { toTranslate: false });
              /** track user email */
              // trackUserEmail(tracking, reply);
              trackInput(tracking, `${summary['summary.proceedOption']}_enter_email_optinal`, reply);
              appointmentSummary.email = reply !== intl.formatMessage({ id: 'welcome.skip' }) ? reply : '';
              this.setState({ appointmentSummary });

              onGeneratePDf().then((refCode) => {
                ultilitiesService.handleCompleteProspect(refCode, summary, intl, tracking, -1, trackCompleteProspect);

                if (isIOS || isMobileSafari) {
                  window.location.assign(`${process.env.REACT_APP_COB_URL}/login?refCode=${refCode}`);
                } else window.open(`${process.env.REACT_APP_COB_URL}/login?refCode=${refCode}`, '_self');
              });
            }}
              // type="email"
            skipable={messageOptions.skipOn === 'go_to_cob' ? intl.formatMessage({ id: 'welcome.skip' }) : null}
            rtl={isRtl}
          />
        );
        break;
      default:
        input = '';
    }
    // moment().isSameOrAfter(moment(1586654916373))
    // console.log('DATE >>> ', moment(20200410));
    return (
      <LayoutChat
        {...this.props}
        conversations={conversations}
        input={input}
        navTitle="cta.title"
        leftButton={<FontAwesomeIcon icon={faRedo} />}
        onLeftClick={this.handleRestart}
        rightButton={<img src={iconClose} alt="X" />}
        onRightClick={() => this.props.history.goBack()}
        onFinish={this.handleFinish}
        displaySavedConvo={false}
      />
    );
  }
}

const mapStateToProps = state => ({
  conversations: state.rootReducer.callToAction,
  fundDetail: state.fundFactsheetReducer.fundDetail,
  inputComponent: state.rootReducer.inputComponent,
  inputOptions: state.rootReducer.inputOptions,
  messageOptions: state.rootReducer.messageOptions,
  summary: state.rootReducer.summary,
  submitAppointmentSuccess: state.ctaReducer.submitAppointmentSuccess,
  submitAppointmentFailure: state.ctaReducer.submitAppointmentFailure,
  userInfo: state.rootReducer.userInfo,
  isRtl: getRTL(state.rootReducer),
  simulationData: getSimulationData(state),
  currentLocale: state.rootReducer.language.locale,
  referenceCode: state.ctaReducer.referenceCode,
});

const mapDispatchToProps = ({
  onReplySubmit: submitReply,
  onUpdateSummary: updateSummary,
  onUpdateStep: updateStep,
  onSubmitAppointment: submitAppointment,
  onClearConversationHistory: clearConversationHistory,
  onSendEmail: sendEmail,
  onGeneratePDf: generatePDf,
});

export default track({
  page: 'CallToAction',
})(connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(CallToAction)));
